const {KitModule, registerModule} = window;

class FormSwitcher extends KitModule {
  constructor($element) {
    super($element);
    this.bindEvents();
  }

  bindEvents() {
    this.$select.addEventListener('change', this);
  }

  onchange() {
    const formId = this.$select.options[this.$select.selectedIndex].dataset.id;
    const form = this.$element.querySelector(`#form-switcher-${formId}`);

    this.$form.forEach(($form) => {
      $form.classList.remove('formSwitcher__form--active');
    });

    form.classList.add('formSwitcher__form--active');

    const hsFormElement = form.querySelector('.hubspotForm');
    if (hsFormElement && window.mountedModules) {
      const hsModule = window.mountedModules.find((m) => m.$element === hsFormElement);
      if (hsModule && typeof hsModule.loadForm === 'function') {
        hsModule.loadForm();
      }
    }
  }
}

registerModule('FormSwitcher', FormSwitcher);
